import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Checkbox, Divider, FormControlLabel, FormLabel, IconButton, Radio, RadioGroup } from "@mui/material";
import { useState } from "react";
import CardYt from "./CardYt";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { addWidget } from "../../../redux/actions/Content";
import { useTranslation } from "react-i18next"; // Import the hook
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const QUALITY_OPTIONS = ["auto", "small", "medium", "large", 
    // "hd720", "hd1080", "highres"
];
const QUALITY_LABELS = [
  "Auto",
  "Lowest",
  "Medium",
  "High",
//   "HD 720p",
//   "Full HD 1080p",
//   "Highest",
];

const buildYouTubeUrl = (videoId, mute, quality) => {
  const params = new URLSearchParams({
    autoplay: "1",
    mute: mute ? "1" : "0",
    rel: "0",
    quality,
  });

  return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
};

export default function DialogBoxYt({ isOpen, onClose, onTakeData, isIcon, onAddWidget, startupData }) {
  const { t } = useTranslation(); // Initialize the translation hook
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [item, setItem] = useState({});
  const [mute, setMute] = useState(false);
  const [quality, setQuality] = useState("auto");
  const dispatch = useDispatch();
  const { currentFolder } = useSelector((state) => state.FileFolder);
  const { user } = useSelector((state) => state.User);

  React.useEffect(() => {
    handleClickOpen();
  }, [isOpen]);

  const handleClickOpen = () => {
    if (isOpen) {
      setName("");
      setUrl("");
      setQuality("auto");
    }
    if (onClose) {
      setName("");
      setUrl("");
      setQuality("auto");
    }
    if(startupData) {
      setName(startupData?.name)
      setUrl(`https://www.youtube.com/watch?v=${new URL(startupData?.widget?.url?.split('?')[0]).pathname.split('/')[2]}`)

      const qualityMatch = startupData?.widget?.url?.match(/[?&]quality=([^&#]*)/);
      const qualityValue = qualityMatch ? decodeURIComponent(qualityMatch[1]) : "auto";
      setQuality(QUALITY_OPTIONS.includes(qualityValue) ? qualityValue : "auto");

      if(startupData?.widget?.url?.includes('mute=1')){
        setMute(true)
      }else if(startupData?.widget?.url?.includes('mute=0')){
        setMute(false)
      }
    }
  };

  const handleMute = (e) => {
    const { checked } = e.target;
    checked ? setMute(true) : setMute(false);
  };

  const handleQualityChange = (e) => {
    setQuality(e.target.value);
  };

  const handleAdd = () => {
    const ytId = (() => {
      var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      var match = url.match(regExp);
      return match && match[2].length == 11 ? match[2] : false;
    })();

    if (name === "") {
      toast.error(t("views.dialogBoxYt.fillRequiredFields"));
      return;
    }

    if (ytId) {
      setItems((previous) => [...previous, { title: name, url, id: ytId }]);
      onTakeData({ title: name, url, id: ytId, isIcon, quality });
      const emUrl = buildYouTubeUrl(ytId, mute, quality);
      const htmltostr = `<iframe title="Youtube Video" width="329px" height="288px" style={{ border: "1px solid black", borderRadius: "10px" }} src={"${emUrl}"} ></iframe>`
        .replace(/"/g, '\\"')
        .replace(/\n/g, "\\n")
        .toString();
      onAddWidget({
        name,
        type: "widget",
        widgetCat: "youtube",
        widgetIcon: isIcon,
        quality,
        url: emUrl,
        html: htmltostr.replace(/\\"/g, '"').replace(/\\n/g, "\n"),
        folderId: currentFolder,
        user: user._id,
      });
      setName("");
      setUrl("");
      setQuality("auto");
      setItem({});
      setPreviewOpen(false);
      //toast.success(t("views.dialogBoxYt.success"));
      onClose();
    } else {
      setName("");
      setUrl("");
      toast.error(t("views.dialogBoxYt.invalidUrl"));
    }
  };

  const handlePreviewOpen = () => {
    // console.log(startupData?.widget?.url, url)
    if(startupData?.widget?.url?.split('?')[0] !== url){
      const array = url.split(".");
      const ytId = url.split("=");
      const emUrl = buildYouTubeUrl(ytId[1], mute, quality);
      if (array[1] === "youtube") {
        setItem({ title: name, url: emUrl, id: ytId[1] });
        setPreviewOpen(true);
      } else {
        toast.error(t("views.dialogBoxYt.invalidUrl"));
      }
    }else{
      setItem({ title: name, url: startupData?.widget?.url, id: ''});
      setPreviewOpen(true);
    }
  };

  const handlePreviewClose = () => {
    setPreviewOpen(false);
    setItem({});
  };

  return (
    <>
      <Dialog fullWidth open={isOpen} onClose={() => onClose(false)}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <img src="/images/youtubeIcon.png" alt="" width={"15%"} style={{ alignSelf: "center", marginTop: "20px" }} />
        </div>
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>{t("views.dialogBoxYt.youtube")}</DialogTitle>
        <DialogContent sx={{ minHeight: "30vh" }}>
          <div
            style={{
              display: "flex",
              marginTop: 20,
              justifyContent: "space-between",
              alignItems: "center",
            }}>
            <DialogContentText sx={{ fontWeight: "bold" }}>{t("views.dialogBoxYt.name")}</DialogContentText>
            <TextField
              id="outlined-basic"
              label={t("views.dialogBoxYt.yourName")}
              variant="outlined"
              fullWidth
              sx={{ marginLeft: 3, width: "465px" }}
              value={name}
              onChange={(e) => setName(e.target.value)}
              disabled={startupData ? true : false}
            />
          </div>
          <div
            style={{
              display: "flex",
              marginTop: 20,
              justifyContent: "space-between",
              alignItems: "center",
            }}>
            <DialogContentText sx={{ fontWeight: "bold" }}>{t("views.dialogBoxYt.url")}</DialogContentText>
            <TextField
              id="outlined-basic"
              label="URL"
              variant="outlined"
              fullWidth
              sx={{ marginLeft: 3, width: "390px"}}
              value={url}
              onChange={(e) => setUrl(e.target.value)}
            />
            <IconButton sx={{
                marginRight: "10px"
            }} role="a" href={url} target="_blank">
                <OpenInNewIcon />
            </IconButton>
          </div>
          <div
            style={{
              display: "flex",
              marginTop: 10,
              alignItems: "center",
            }}>
            <DialogContentText sx={{ fontWeight: "bold" }}>{t("views.dialogBoxYt.mute")}</DialogContentText>
            <Checkbox sx={{ marginLeft: 4 }} checked={mute ? true : false} onChange={handleMute} />
          </div>
          <Divider sx={{
            my: 2
          }}/>
          <div
            style={{
              display: "flex",
              marginTop: 10,
              justifyContent: "space-between",
              alignItems: "center",
            }}>
            {/* <DialogContentText sx={{ fontWeight: "bold" }}>Quality</DialogContentText> */}
            <FormControl fullWidth sx={{ width: "465px" }}>
              {/* <InputLabel id="youtube-quality-select-label">Quality</InputLabel>
              <Select
                labelId="youtube-quality-select-label"
                id="youtube-quality-select"
                value={quality}
                label="Quality"
                onChange={handleQualityChange}
              >
                {QUALITY_OPTIONS.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select> */}
                <FormLabel id="youtube-quality-select-label">Quality</FormLabel>
                <RadioGroup
                    aria-labelledby="youtube-quality-select-label"
                    // defaultValue="female"
                    value={quality}
                    onChange={handleQualityChange}    
                >
                    {QUALITY_OPTIONS.map((option, index) => (
                        <FormControlLabel key={option} value={option} control={<Radio />} label={QUALITY_LABELS[index]} />
                    ))}    
                </RadioGroup>              
            </FormControl>
          </div>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 2,
            marginTop: 1,
          }}>
          <div>
            <Button variant="contained" color="primary" onClick={handlePreviewOpen}>
              {t("views.dialogBoxYt.preview")}
            </Button>
          </div>
          <div>
            <Button onClick={() => onClose(false)}>{t("views.dialogBoxYt.cancel")}</Button>
            <Button variant="contained" color="primary" onClick={handleAdd}>
              {t("views.dialogBoxYt.save")}
            </Button>
          </div>
        </DialogActions>
      </Dialog>

      <Dialog fullWidth open={previewOpen} onClose={handlePreviewClose}>
        <img src="/images/youtubeIcon.png" alt="" width={"15%"} style={{ alignSelf: "center", marginTop: "20px" }} />
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>{t("views.dialogBoxYt.youtube")}</DialogTitle>
        <DialogContent
          sx={{
            backgroundColor: "#e5e3e3",
            minHeight: "30vh",
            display: "flex",
            justifyContent: "center",
          }}>
          <div>
            <CardYt item={item} />
          </div>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 2,
            marginTop: 1,
          }}>
          <div>
            <Button variant="contained" color="primary" onClick={handleAdd}>
              {t("views.dialogBoxYt.confirm")}
            </Button>
          </div>
          <div>
            <Button onClick={handlePreviewClose}>{t("views.dialogBoxYt.cancel")}</Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
